module.exports = __webpack_public_path__ + "img/volume-slash.f7851154.svg";